// @flow
import * as React from 'react';
import { Collapse } from '../../azalea/components/collapse';
import type { DataProvidesProps } from '../utils/constants';

type Props = {
  children: React.Node,
  /**
   * Required for proper accessibility support
   */
  id: string,
  /**
   * If the children of the component should be rendered
   */
  isOpen: boolean,
  ...DataProvidesProps,
};

const Collapsible = (props: Props) => {
  const { isOpen, ...otherProps } = props;

  return <Collapse isOpened={isOpen} {...otherProps} />;
};

Collapsible.defaultProps = { 'data-provides': 'collapsible' };

export default Collapsible;
